import React, { useMemo, useState } from 'react';
import { createPortal } from 'react-dom';
import useAddToHomeScreen from 'hooks/useAddToHomeScreen';
import Cookies from 'js-cookie';
import { CookieNames } from 'config/constants';
import { AddToHomeScreenMask } from './AddToHomeScreen.styled';

function AddToHomeScreen() {
    // Сегодняшняя дата в формате DD-MM-YYYY
    const today = useMemo(
        () => {
            const date = new Date();

            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();

            return `${day}-${month}-${year}`;
        },
        [],
    );
    // Проверяем отображался ли сегодня блок
    const initCanShow = Cookies.get(CookieNames.AddToHomeScreenShown) !== today;
    const [canShow, setCanShow] = useState<boolean>(initCanShow);
    const isProd = process.env.NODE_ENV === 'production';
    const { prompt, promptToInstall } = useAddToHomeScreen();
    const canInstallApp = !!prompt;

    const handleClick = () => {
    // Отключаем возможность отображения невидимого блока, когда по нему уже был клик, до след обновления страницы
        setCanShow(false);
        // Сохраняем состояние, о сегодняшнем показе блока
        Cookies.set(CookieNames.AddToHomeScreenShown, today);
        promptToInstall();
    };

    // Отображаем невидимый блок, только если есть поддержка prompt
    if (canInstallApp && canShow && isProd) {
        return createPortal(
            <AddToHomeScreenMask onClick={handleClick} />,
            document.getElementById('add-to-home-screen-portal') as HTMLElement,
        );
    }
    return null;
}

export default AddToHomeScreen;
